import styled from 'styled-components';
import Screen from '../../../../shared/utils/screen';

/**
 * Styled container component for play icon button in pause ad modal.
 * Displays a circular play button overlay on the pause ad.
 */
const PauseAdPlayIconContainer = styled.div`
  background: rgba(255, 255, 255, 0.8);
  position: fixed;
  padding-left: ${10 * Screen.widthRatio}px;
  border-radius: ${50 * Screen.widthRatio}px;
  top: ${524 * Screen.widthRatio}px;
  left: ${170 * Screen.widthRatio}px;
  width: ${78 * Screen.widthRatio}px;
  height: ${88 * Screen.widthRatio}px;
  justify-content: center;
  align-items: center;
  display: flex;
`;

export default PauseAdPlayIconContainer;
